import {Component, OnDestroy, OnInit} from '@angular/core';
import {SearchService} from 'src/app/services/search.service';
import {BadgeClasses, ProductInfo} from '../../models/product';
import {takeUntil} from 'rxjs/operators';
import {BusyConfig} from '@bmc-ux/adapt-angular';
import {Observable, Subject} from 'rxjs';

@Component({
  selector: 'app-recently-viewed-products',
  templateUrl: './recently-viewed-products.component.html',
  styleUrls: ['./recently-viewed-products.component.sass']
})
export class RecentlyViewedProductsComponent implements OnInit, OnDestroy {
  public badgeClasses = BadgeClasses;
  public recentlyViewedProducts: ProductInfo[];
  public lastEditedProds: ProductInfo[];
  public recentlyReleasedProds: ProductInfo[];

  public recentlyViewedBusyConfig: BusyConfig = {
    loaderType: 'inline',
    backdrop: false
  };
  public lastEditedBusyConfig: BusyConfig = {
    loaderType: 'inline',
    backdrop: false
  };
  public recentlyReleasedBusyConfig: BusyConfig = {
    loaderType: 'inline',
    backdrop: false
  };

  private onComponentDestroyed$: Subject<void> = new Subject();

  constructor(private searchService: SearchService) {
  }

  ngOnInit(): void {
    this.recentlyViewedBusyConfig = ({
      ...this.recentlyViewedBusyConfig,
      busy: new Observable().pipe(
        takeUntil(this.onComponentDestroyed$),
      ).subscribe()
    });
    this.lastEditedBusyConfig = ({
      ...this.lastEditedBusyConfig,
      busy: new Observable().pipe(
        takeUntil(this.onComponentDestroyed$),
      ).subscribe()
    });
    this.recentlyReleasedBusyConfig = ({
      ...this.recentlyReleasedBusyConfig,
      busy: new Observable().pipe(
        takeUntil(this.onComponentDestroyed$),
      ).subscribe()
    });

    const userInfo = JSON.parse(localStorage.getItem('okta-token-storage'));

    if (userInfo && userInfo.accessToken) {
      this.recentlyViewedBusyConfig.busy = this.searchService.getRecentlyViewedProducts().pipe(
        takeUntil(this.onComponentDestroyed$)
      ).subscribe((products: ProductInfo[]) => {
        this.recentlyViewedProducts = products.slice(0, 20);
      });

      this.lastEditedBusyConfig.busy = this.searchService.getLastModifiedProducts().pipe(
        takeUntil(this.onComponentDestroyed$)
      ).subscribe((products: ProductInfo[]) => {
        this.lastEditedProds = products.slice(0, 10);
      });

      this.recentlyReleasedBusyConfig.busy = this.searchService.getRecentlyReleasedProducts().pipe(
        takeUntil(this.onComponentDestroyed$)
      ).subscribe((products: ProductInfo[]) => {
        this.recentlyReleasedProds = products.slice(0, 10);
      });
    }
  }

  ngOnDestroy(): void {
    this.onComponentDestroyed$.next();
    this.onComponentDestroyed$.complete();
    this.onComponentDestroyed$.unsubscribe();
  }
}
